import { useRequiredContext } from "@redotech/react-util/context";
import { UserContext } from "@redotech/redo-merchant-app-common/user";
import { isRedoEmailAddress } from "@redotech/redo-model/redo-domains";
import { createContext, memo, type ReactNode, useContext } from "react";

const IntelligentCycleCountsContext = createContext<boolean | undefined>(
  undefined,
);

export function useIntelligentCycleCountsFlag(): boolean {
  return useRequiredContext(IntelligentCycleCountsContext);
}

export const IntelligentCycleCountsFlagProvider = memo(
  function IntelligentCycleCountsFlagProvider({
    children,
  }: {
    children: ReactNode;
  }) {
    const user = useContext(UserContext);
    const enabled = isRedoEmailAddress(user?.email);

    return (
      <IntelligentCycleCountsContext.Provider value={enabled}>
        {children}
      </IntelligentCycleCountsContext.Provider>
    );
  },
);
